// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.image[data-v-5557a223] {\n\tmax-width:100%;\n\tmax-height:100%;\n\twidth:100%;\n\theight:100%;\n\t-o-object-fit:contain;\n\t   object-fit:contain;\n}\n.container[data-v-5557a223] {\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tpointer-events:all;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
